import { render, staticRenderFns } from "./CourseSearch.vue?vue&type=template&id=446e2538"
import script from "./CourseSearch.vue?vue&type=script&lang=js"
export * from "./CourseSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports